import * as XLSX from 'xlsx';
import { format } from 'date-fns';

const r2 = (v) => Number((Number(v) || 0).toFixed(2));

/**
 * Günlük / haftalık / aylık rapor ekranlarının hazır `rapor` verisinden Excel üretir.
 * Yeni hesap yapmaz; ekranda görünen toplamlar aynen yazılır.
 */
export function exportRaporExcel(rapor, { dosyaAdi, tarihFormati = 'HH:mm', tarihBasligi = 'Saat' }) {
  const wb = XLSX.utils.book_new();

  const ozet = [
    ['Tür', 'Adet', 'Nakit', 'Havale/EFT', 'Kredi Kartı', 'Toplam'],
    ...[['Satış', rapor.satis], ['Alış', rapor.alis], ['Giriş', rapor.giris], ['Çıkış', rapor.cikis]]
      .map(([ad, d]) => [ad, d.adet, r2(d.nakit), r2(d.havale), r2(d.kart), r2(d.toplam)]),
    [],
    ['Toplam işlem sayısı', rapor.toplamIslemSayisi],
    ['Kasaya giren nakit', r2(rapor.kasayaGirenNakit)]
  ];
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(ozet), 'Özet');

  const urunSatirlari = [['Kategori', 'Ürün', 'Satış', 'Alış', 'Giriş', 'Çıkış', 'Net']];
  Object.entries(rapor.kategoriler).forEach(([kat, { urunler }]) => {
    Object.entries(urunler).forEach(([ad, v]) => {
      if (v.satis || v.alis || v.giris || v.cikis) {
        urunSatirlari.push([kat, ad, v.satis, v.alis, v.giris, v.cikis, v.net]);
      }
    });
  });
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(urunSatirlari), 'Ürünler');

  const islemSatirlari = [[tarihBasligi, 'İşlem No', 'Müşteri / Firma', 'Tür', 'Kategori', 'Ürün', 'Adet', 'Gram', 'Nakit', 'Havale/EFT', 'Kredi Kartı', 'Toplam']];
  rapor.islemler.forEach((i) => {
    const isTL = i.kategori === 'Döviz' && i.urun === 'TL - Türk Lirası';
    const taraf = [i.musteri?.isim, i.musteri?.soyisim].filter(Boolean).join(' ').trim()
      || i.firma?.firmaIsmi || '';
    islemSatirlari.push([
      format(i.tarih, tarihFormati),
      i.islemNo || '',
      taraf || '-',
      i.islemTuru || '',
      i.kategori || '',
      i.urun || '',
      isTL ? r2(i.nakit) : (Number(i.adet) || 0),
      isTL ? 0 : r2(i.gram),
      r2(i.nakit),
      r2(i.havaleEft),
      r2(i.krediKarti),
      r2(i.toplamTutar)
    ]);
  });
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(islemSatirlari), 'İşlemler');

  XLSX.writeFile(wb, dosyaAdi);
}
